import Logger from '../logger';

class OrderConflictChecker extends HTMLElement {
  #NAME= 'OrderConflictChecker';
  #abortController;
  #windowAbortController;
  #btnDisabled = false;
  #hasConflict = false;
  #hasListeners = false;
  #shippingTypes;
  #productShippingType;
  #dateInput;
  #zipInput;

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.#dateInput = this.querySelector('input[name="attributes[deliveryDate]"]');
    this.#zipInput = this.querySelector('input[name="attributes[zipCode]"]');
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.#windowAbortController =  new AbortController();
    const { signal } = this.#windowAbortController;
    window.addEventListener('resize', () => {
      if (this.clientHeight && !this.#hasListeners) {
        this.#addListeners();
      } else if (this.#hasListeners) {
        this.#removeListeners();
      }
    }, { signal });
    if (this.clientHeight) this.#addListeners();
  }

  disconnectedCallback() {
    this.#removeListeners();
    this.observer2.disconnect();
    this.observer2 = null;
    this.#windowAbortController.abort()
    this.#windowAbortController = null;
  }

  static get observedAttributes() {
    return ['shipping-type'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'shipping-type') {
      this.#productShippingType = newValue.toLowerCase();
      Logger.info(`${this.#NAME} > shippingType > ${this.#productShippingType}`);
    }
  }

  #removeListeners() {
    Logger.info(`${this.#NAME} > removeListeners`);
    if (this.#abortController) {
      this.#abortController.abort()
      this.#abortController = null;
    }
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.#hasListeners = false;
  }

  async #addListeners() {
    Logger.info(`${this.#NAME} > addListeners`);
    this.#abortController =  new AbortController();
    const { signal } = this.#abortController;
    await this.#checkForLocal();
    this.addEventListener('click', () => this.#onClick(), { signal });
    this.#hasListeners = true;
    const inputZipDiv = document.querySelector('[data-zip-code-input-area]');
    const inputDateDiv = document.querySelector('[data-calendar-input-area]');
    if (inputZipDiv && inputDateDiv) {
      const mutationCallback = (mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            /* console.log(inputAreaDiv.clientHeight); */
            if (!inputZipDiv.clientHeight || !inputZipDiv.clientHeight) {
              setTimeout(() => {
                this.#checkForLocal();
              }, 100);
            }
          }
        }
      };
      this.observer = new MutationObserver(mutationCallback);
      this.observer.observe(inputZipDiv, { attributes: true });
      this.observer.observe(inputDateDiv, { attributes: true });
      //
      const shopPayBtns = document.querySelectorAll('.shopify-payment-button');
      if (shopPayBtns) {
        const mutationCallback2 = (mutationList) => {
          for (const mutation of mutationList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              if (mutation.target.style.display == 'none') {
                mutation.target.removeAttribute('style');
              }
            }
          }
        };
        this.observer2 = new MutationObserver(mutationCallback2);
        shopPayBtns.forEach(btn => {
          this.observer2.observe(btn, { attributes: true });
        })
      }
    }
  }

  async #checkForLocal() {
    Logger.info(`${this.#NAME} > checkForLocal`);
    const zipCode = localStorage.getItem('zipCode');
    if (!zipCode || !window.localZipCodes) {
      Logger.info(`${this.#NAME} > isLocal > can't evaluate`);
      return false;
    }
    //
    this.#dateInput.value = localStorage.getItem('deliveryDate'); /* console.log(this.#dateInput.value); */
    this.#zipInput.value = zipCode; /* console.log(this.#zipInput.value); */
    //
    const isLocal = window.localZipCodes.includes(zipCode);
    if (isLocal) {
      Logger.info(`${this.#NAME} > isLocal > true`);
      if (this.#btnDisabled) {
        this.childNodes.forEach(el => {
          if (el.style) el.style.pointerEvents = 'all';
        });
        this.#btnDisabled = false;
      }
      return true;
    } else {
      Logger.info(`${this.#NAME} > isLocal > false`);
      //
      this.childNodes.forEach(el => {
        if (el.style) el.style.pointerEvents = 'none';
      });
      this.style.cursor = 'pointer';
      this.#btnDisabled = true;
      //
      const resp = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await resp.json();
      //console.log(cart);
      this.#shippingTypes = new Set(cart.items.map(item => item.properties._shipping_type).filter(t => t).map(t => t.toLowerCase()));
      
      this.#hasConflict = this.#checkForConflict();
      Logger.info(`${this.#NAME} > hasConflict > ${this.#hasConflict}`);
      return true;
    }
  }

  #onClick() {
    if (this.#btnDisabled) {
      if (this.#hasConflict) {
        // show popup
        const modal = document.querySelector('order-conflict-modal');
        modal.dataset.show = 'true';
      } else {
        const button = this.querySelector('button[type="submit"]');
        button.click();
      }
    }
  }

  #checkForConflict() {
    Logger.info(`${this.#NAME} > checkForConflict > cur type: ${this.#productShippingType} > types in cart: ${JSON.stringify(Array.from(this.#shippingTypes))}`);
    if (this.#shippingTypes.size) {
      if (this.#productShippingType.startsWith('direct') && this.#shippingTypes.has('non-direct ship')) {
        return true;
      } else if (this.#productShippingType === 'non-direct ship' && (this.#shippingTypes.has('direct ship') || this.#shippingTypes.has('direct floral'))) {
        return true;
      }
    }
    return false;
  }
}

customElements.define('order-conflict-checker', OrderConflictChecker);